export default __webpack_public_path__ + "static/media/11.72e1db33.jpg";